module.exports = __webpack_public_path__ + "static/media/news-sph-02.0c29c095.jpg";